import axios from "axios/index";
import { API } from "../utilities/api.config";

function getGeneralMetrics() {
  return (dispatch) => {
    dispatch({
      type: "GENERAL_METRICS_REQUESTED",
    });
    axios
      .get(API.GET_GENERAL_METRICS, {
        headers: { Authorization: `${localStorage.getItem("wbiAuthToken")}` },
      })
      .then((response) => {
        dispatch({
          type: "GENERAL_METRICS_SUCCESS",
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "GENERAL_METRICS_FAIL",
          payload: error,
        });
        if (error.response.status === 401) {
          dispatch({
            type: "LOGOUT",
          });
        }
      });
  };
}

export const metricAction = {
  getGeneralMetrics,
};

export default metricAction;



// WEBPACK FOOTER //
// ./src/actions/metric.action.js